import {
  LoadingOutlined,
  DownCircleOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  UpCircleOutlined,
  UploadOutlined,
  DeleteOutlined,
  AudioOutlined,
  CustomerServiceOutlined,
  UserOutlined,
  StarFilled,
} from '@ant-design/icons';
import { getAudioDurationInSeconds } from '@remotion/media-utils';
import { useGetVoices } from '../../api/elevenLabs/getVoices';
import { categorisedMusicList, whisperAiVoiceList } from '../../data/music';
import {
  Button,
  InputNumberProps,
  Row,
  Col,
  Select,
  Slider,
  SliderSingleProps,
  Switch,
  Tag,
  message,
  Upload,
  Input,
  Tooltip,
  Popconfirm,
  Tabs,
  Modal,
} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useGlobalContext } from '../../context/globalContext';
import { AiVoiceRow } from '../video/customVideoTimeline/cardRows/aiVoiceRow';
import './audioPanel.less';
import { generateUniqueId } from '../../shared/utils/core';
import { aiVoicesResponse } from '../../data/aiVoiceResponse';
import { formatDuration } from '../../shared/utils/convertSecs';
import { prefetchAsset } from '../../shared/utils/remotion';
import { IS_FREE_PLATFORM } from '../../config';
import { getDomainID, getToken } from '../../config/config';
import {
  aiTextToSpeech,
  generateCaptions,
  generateElevenLabsPayloads,
  getPrevNextText,
} from '../../shared/utils/VideoGeneration/audioGeneration';
import { TranslateAudio } from '../translate/translateAudio';
import {
  creditsDeduct,
  getUserDetails,
  voiceCloneAPI,
} from '@src/shared/utils/VideoGeneration/helperFunctions/mediaSearch';
import { warning } from '@remix-run/router/dist/history';
import {
  deleteClonedVoice,
  getClonedVoices,
  saveClonedVoices,
} from '@src/shared/utils/VideoGeneration/helperFunctions/voiceCloneApi';
import { uploadFile } from '@src/shared/utils/VideoGeneration/uploadAsset';
import { useGetBGMusic } from '@src/api/useGetBgMusic';
import { VoiceFilterModal } from './audioFilterModal';
import { SectionTab } from 'polotno/side-panel';
import { VolumeHighIcon } from '../polotno/component/hugeIcons/hugeIcons';
const { Option } = Select;

interface AudioSidebarProps {
  store: any;
}

interface MusicDetails {
  30: { PAS?: string[] };
}

interface ClonedVoiceData {
  user_id: string;
  voice_name: string | null;
  createdAt: string;
  id: string;
  voice_id: string | null;
  updatedAt: string | null;
}

const labelTypeColors: { [key: string]: string } = {
  accent: 'magenta',
  description: 'green',
  age: 'cyan',
  gender: 'volcano',
  'use case': 'blue',
};


export const aiVoiceDropDown = [
  {
    label: 'AI Voices',
    options: whisperAiVoiceList.map((aiVoice) => ({
      label: <span>{aiVoice.label}</span>,
      value: aiVoice.value,
    })),
  },
];

export const generateMusicOptions = (myMusics: any[], audioState: { isPlaying: boolean, currentTrack: string | null }, togglePlayPause: (track: string) => void) => {
  const myMusicOptions: any[] = [];
  myMusics?.map((musicUrl: any, index: number) => {
    const option = {
      label: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ flex: 1 }}>{musicUrl.asset_name}</div>
          <Button
            type='text'
            icon={
              audioState.isPlaying && audioState.currentTrack === musicUrl?.audio_url ? (
                <PauseCircleOutlined />
              ) : (
                <PlayCircleOutlined />
              )
            }
            onClick={(e) => {
              e.stopPropagation();
              togglePlayPause(
                `Others@@@${musicUrl?.audio_url}@@@${musicUrl.asset_name}`
              );
            }}
          />
        </div>
      ),
      value: `Others@@@${musicUrl?.audio_url}@@@${musicUrl.asset_name}`,
    };
    myMusicOptions.push(option);
  });
  return myMusicOptions;
};


export const generateCategoryMusicOptions = (
  categories: string[],
  categorisedMusicList: any,
  audioState: { isPlaying: boolean, currentTrack: string | null },
  togglePlayPause: (track: string) => void,
  options: any
) => {
  categories.map((category) => {
    const musicList = categorisedMusicList[category][60]['PAS'];
    musicList.map((musicUrl: any) => {
      const musicKey = `${category}@@@${musicUrl.url}@@@${musicUrl.name}`;
      const option = {
        label: (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ flex: 1 }}>{musicUrl.name}</div>
            <div
              style={{
                flex: '0 0 auto',
                marginLeft: '10px',
                marginRight: '2px',
              }}
            >
              {musicUrl.duration}
            </div>
            <Button
              type='text'
              icon={
                audioState.isPlaying && audioState.currentTrack === musicUrl?.url ? (
                  <PauseCircleOutlined />
                ) : (
                  <PlayCircleOutlined />
                )
              }
              onClick={(e) => {
                e.stopPropagation();
                togglePlayPause(musicKey);
              }}
            />
          </div>
        ),
        value: musicKey,
      };
      if (options[category]) {
        options[category].push(option);
      } else {
        options[category] = [option];
      }
    });
  });
};

export const AudioSidebar = ({ store }: AudioSidebarProps) => {
  const {
    BackgroundMusic: [backgroundMusic, setBackgroundMusic],
    UserDetail: [userDetails, setUserDetails],
    ScriptDetails: [scriptDetails, setScriptDetails],
    AudioFade: [audioFade, setAudioFade],
    VideoStyle: [videoStyle, setVideoStyle],
    CurrentUserData: [currentUserData, setCurrentUserData],
    PreviewLoader: [isPreviewLoading, setIsPreviewLoading],
    ActiveSidePanel: [, setActiveSidePanel],
  } = useGlobalContext();
  useEffect(() => {
    setActiveSidePanel(store.openedSidePanel);
  }, []);
  const [selectedIndustryName, setSelectedIndustryName] = useState(
    `${scriptDetails?.backgroundMusic?.industry}`
  );
  const [selectedMusicUrl, setSelectedMusicUrl] = useState(
    `${scriptDetails?.backgroundMusic?.url}`
  );
  const [selectedMusicName, setSelectedMusicName] = useState(
    `${scriptDetails?.backgroundMusic?.name}`
  );
  const [playingUrl] = useState('');
  const [showVoiceOver, setShowVoiceOver] = useState(false);
  const [showAdvanedVoiceSetting, setshowAdvanedVoiceSetting] = useState(false);
  const [showAdvanedBackgroundSetting, setShowAdvanedBackgroundSetting] = useState(false);

  const [selectedVoiceName, setSelectedVoiceName] = useState(
    `${scriptDetails?.data?.[0]?.name || 'Custom'}`
  );
  const [backgroundVolume, setBackgroundVolume] = useState(
    (scriptDetails?.backgroundMusic?.backgroundVolume ?? 0.1) * 100
  );
  const [aiVoiceVolume, setAiVoiceVolume] = useState(
    (scriptDetails?.aiVoiceVolume ?? 1) * 100
  );
  const [aiVoiceSpeed, setAiVoiceSpeed] = useState(
    scriptDetails?.aiVoiceSpeed ?? 1
  );
  const [voiceChanging, setVoiceChanging] = useState(false);
  const [translateloading, setTranslateloading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [backgroundFileList, setBackgroundFileList] = useState([]);
  const [IsCloning, setIsCloning] = useState(false);
  const [IsBackgroundUploading, setIsBackgroundUploading] = useState(false);
  const [myMusics, setMyMusics] = useState<any>([]);
  const [isSizeExceeded, setIsSizeExceeded] = useState(false);
  const formatter: NonNullable<SliderSingleProps['tooltip']>['formatter'] = (
    value: any
  ) => `${value}%`;
  const voiceSpeedformatter: NonNullable<
    SliderSingleProps['tooltip']
  >['formatter'] = (value) => `${value} x`;

  const [voiceName, setVoiceName] = useState('');
  const [backgroundMusicName, setBackgroundMusicName] = useState('');

  const [ClonedVoiceData, setClonedVoiceData] = useState<ClonedVoiceData[]>([]);
  const [customVoiceCloning, setCustomVoiceCloning] = useState(false);
  // const speedformatter: NonNullable<SliderSingleProps['tooltip']>['formatter'] = (value: any) => `${value}x`
  const speedformatter = (value: any) => `${value}x`;
  // Ref to the audio player
  // const audioRef = React.createRef<HTMLAudioElement>()
  const audioRef = useRef<HTMLAudioElement>(null);

  const [currentPlayingTrack, setCurrentPlayingTrack] = useState<string | null>(
    null
  );
  const { data: aiVoice, isLoading, isSuccess } = useGetVoices();

  const {
    data: backgroundMusicData,
    isError,
    error,
    refetch: refetchaudio,
  } = useGetBGMusic(1, 'audio', 'bg');

  useEffect(() => {
    if (
      backgroundMusicData &&
      backgroundMusicData.items &&
      backgroundMusicData.items.length > 0
    ) {

      // setMyMusics([...myMusics, ...backgroundMusicData.items]);
      setMyMusics([...backgroundMusicData.items]);
    }
  }, [backgroundMusicData]);

  // Add state to track which audio is currently playing
  const [audioState, setAudioState] = useState<{
    isPlaying: boolean;
    currentTrack: string | null;
  }>({
    isPlaying: false,
    currentTrack: null
  });

  // Update audio ref event listeners
  useEffect(() => {
    if (!audioRef.current) return;

    const handlePlay = () => {
      setAudioState(prev => ({
        ...prev,
        isPlaying: true
      }));
    };

    const handlePause = () => {
      setAudioState(prev => ({
        ...prev,
        isPlaying: false
      }));
    };

    const handleEnded = () => {
      setAudioState({
        isPlaying: false,
        currentTrack: null
      });
    };

    // Add event listeners
    audioRef.current.addEventListener('play', handlePlay);
    audioRef.current.addEventListener('pause', handlePause);
    audioRef.current.addEventListener('ended', handleEnded);

    // Clean up
    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener('play', handlePlay);
        audioRef.current.removeEventListener('pause', handlePause);
        audioRef.current.removeEventListener('ended', handleEnded);
      }
    };
  }, [audioRef.current]);

  const handlePlayAudio = (previewUrl: string) => {
    if (audioRef.current) {
      audioRef.current.src = previewUrl;

      audioRef.current
        .play()
        .catch((e) => console.error('Playback was interrupted:', e));

      setAudioState({
        isPlaying: true,
        currentTrack: previewUrl
      });
    }
  };

  // Pause audio handler
  const handlePauseAudio = () => {
    if (audioRef.current && !audioRef.current.paused) {
      audioRef.current.pause();

      setAudioState(prev => ({
        ...prev,
        isPlaying: false
      }));
    }
  };

  const togglePlayPause = (value: string) => {
    const [industry, musicUrl, name] = value.split('@@@');

    if (audioState.isPlaying && audioState.currentTrack === musicUrl) {
      handlePauseAudio();
    } else {
      handlePlayAudio(musicUrl);
      setAudioState({
        isPlaying: true,
        currentTrack: musicUrl
      });
    }
  };

  const onVoiceOverVolumeChange = async (newValue: number) => {
    setAiVoiceVolume(newValue);
    await setScriptDetails((prevScript: { data: any }) => {
      const updatedScript = { ...prevScript };

      return { ...updatedScript, aiVoiceVolume: newValue / 100 };
    });
  };

  const [isVoiceSpeedChanging, setIsVoiceSpeedChanging] = useState(false);

  const onVoiceSpeedChange = async (newValue: number, voiceId?: string) => {
    try {
      setIsVoiceSpeedChanging(true);
      setAiVoiceSpeed(newValue);
      const voice = aiVoice?.voices?.find(
        (voice: any) => voice.voice_id === voiceId
      );
      // Generate audio payloads in parallel
      const BulkAudioCaptionList = await generateElevenLabsPayloads(
        scriptDetails.data,
        userDetails,
        setScriptDetails,
        store,
        videoStyle,
        undefined,
        newValue,
        false,
        undefined,
        voiceId,
        voice ? voice?.name : scriptDetails?.data[0]?.name
      );
      setSelectedVoiceName(voice?.name || voiceId)
      // Create a map of scriptIndex to audio duration for faster lookups
      const durationMap = new Map(
        BulkAudioCaptionList.map(item => [
          item.sectionIndex,
          item.output?.newDuration
        ])
      );

      // Update script details and page durations in a single pass

      await setScriptDetails((prevScript: { data: any }) => {
        const updatedData = prevScript.data.map((item: any, index: number) => {
          const audioDuration = durationMap.get(index);
          if (audioDuration) {
            const pagesLength = store.pages.filter(
              (page: any) => page.custom.scriptIndex === index
            ).length;

            // Update page durations in batch
            store.pages
              .filter((page: any) => page.custom.scriptIndex === index)
              .forEach((page: any) => {
                page.set({
                  duration: audioDuration / pagesLength
                });
              });
          }
          return item;
        });

        return {
          ...prevScript,
          aiVoiceSpeed: newValue,
          data: updatedData
        };
      });
    } catch (error) {
      console.error('Error updating voice speed:', error);
      message.error('Failed to update voice speed. Please try again.');
    } finally {
      setIsVoiceSpeedChanging(false);
    }
  };

  const handleVoiceSpeedChange = (newValue: number) => {
    Modal.confirm({
      title: 'Change Voice Speed',
      content: `Are you sure you want to change the voice speed to ${newValue}x? This will regenerate all audio.`,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => onVoiceSpeedChange(newValue, scriptDetails?.data[0]?.elevenLabsAiVoiceId),
      onCancel: () => {
        setAiVoiceSpeed(scriptDetails.aiVoiceSpeed);
      }
    });
  };

  const onBackgroundVolumeChange = async (newValue: number) => {
    setBackgroundVolume(newValue as number);

    await setScriptDetails((prevScript: { data: any }) => {
      const updatedScript: any = { ...prevScript };

      return {
        ...updatedScript,
        backgroundMusic: {
          ...updatedScript.backgroundMusic,
          backgroundVolume: newValue / 100,
        },
      };
    });
  };
  const handleFadeInOut = (checked: any, event: any) => {
    // setAudioFade(checked)
    setScriptDetails((prevScript: { data: any }) => {
      const updatedScript = { ...prevScript };

      return { ...updatedScript, audioFade: checked };
    });
  };
  const handleBackgroundMusicChange = async (value: string) => {
    const [industryName, musicUrl, name] = value.split('@@@');

    if (currentPlayingTrack === musicUrl) {
      handlePauseAudio();
    }

    setSelectedIndustryName(industryName);
    setSelectedMusicUrl(musicUrl);
    setSelectedMusicName(name);

    const backgroundAudioDuration = await getAudioDurationInSeconds(musicUrl);
    // setBackgroundMusic({ url: musicUrl, duration: backgroundAudioDuration, industry: industryName, name })

    const backgroundScript = {
      url: musicUrl,
      duration: backgroundAudioDuration,
      industry: industryName,
      name: name,
      backgroundVolume: backgroundVolume / 100,
    };

    // const backgroundAudioDuration = await getAudioDurationInSeconds(musicUrl)
    setBackgroundMusic(backgroundScript);

    await setScriptDetails((prevScript: { data: any }) => {
      const updatedScript = { ...prevScript };

      return { ...updatedScript, backgroundMusic: backgroundScript };
    });
  };


  const subscriptionPlan = currentUserData?.subscription_plan;
  // const subscriptionPlan = 'quickads_tier4'
  if (
    subscriptionPlan !== 'free' &&
    subscriptionPlan !== 'quickads_tier2' &&
    subscriptionPlan !== 'quickads_tier1'
  ) {
    aiVoiceDropDown.push({
      label: 'Premium AI Voices',
      options: aiVoice?.voices
        ?.filter((voice: any) => voice.category !== 'cloned') // Filter voices based on category
        .map((voice: any) => ({
          label: (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span>{voice.name}</span>
                <Button
                  type='text'
                  icon={<PlayCircleOutlined />}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent the select dropdown from closing
                    handlePlayAudio(voice.preview_url);
                  }}
                />
              </div>
              <div className='tag-container'>
                {Object.entries(voice.labels).map(([key, value]) => (
                  <Tag color={labelTypeColors[key] || 'default'} key={key}>
                    {`${value}`}
                  </Tag>
                ))}
              </div>
            </div>
          ),
          value: voice.voice_id, // Value for each option
        })),
    });
  }
  // else {
  //   aiVoiceDropDown.push({
  //     label: 'Premium AI Voices',
  //     options: aiVoice?.voices
  //       ?.filter((voice: any) => voice.category !== 'cloned') // Filter voices based on category
  //       .map((voice: any) => ({
  //         label: (
  //           <div
  //             style={{
  //               display: 'flex',
  //               justifyContent: 'space-between',
  //               flexDirection: 'column',
  //             }}
  //           >
  //             <div style={{ display: 'flex', alignItems: 'center' }}>
  //               <span>{voice.name}</span>
  //               <Button
  //                 type='text'
  //                 icon={<PlayCircleOutlined />}
  //                 onClick={(e) => {
  //                   e.stopPropagation(); // Prevent the select dropdown from closing
  //                   handlePlayAudio(voice.preview_url);
  //                 }}
  //               />
  //             </div>
  //             <div className='tag-container'>
  //               {Object.entries(voice.labels).map(([key, value]) => (
  //                 <Tag color={labelTypeColors[key] || 'default'} key={key}>
  //                   {`${value}`}
  //                 </Tag>
  //               ))}
  //             </div>
  //           </div>
  //         ),
  //         value: voice.voice_id, // Value for each option
  //       })),
  //   });
  //   }

  // Add cloned voices if available
  if (ClonedVoiceData.length > 0) {
    aiVoiceDropDown.push({
      label: '⭐ My Cloned Voices',
      options: ClonedVoiceData.map((voice) => ({
        label: <span>{voice.voice_name && voice.voice_name.length > 15 ? voice.voice_name.slice(0, 15) + '...' : voice.voice_name || voice.id}</span>,
        value: voice.id,
      })),
    });
  }

  const playVoiceSample = async (
    text: string,
    aiVoiceName: string,
    isElevenApi: boolean,
    elevenlabsVoiceId: string | undefined,
    index: number,
    Similarity: number,
    Stability: number,
    enhancedText?: string | undefined
  ): Promise<any> => {
    try {
      videoStyle !== 'Burst' && store.selectPage(store.pages[index].id);
      let domainId;
      let token;

      if (IS_FREE_PLATFORM === 'false') {
        domainId = getDomainID();
        token = getToken();
      }
      const Prevnext = getPrevNextText(scriptDetails.data, index);
      const audioUrl = await aiTextToSpeech(
        text,
        elevenlabsVoiceId,
        domainId,
        aiVoiceName,
        isElevenApi,
        token,
        Prevnext.prevText,
        Prevnext.nextText,
        80,
        80
      );
      // const audioUrl = await aiTextToSpeech(text, elevenlabsVoiceId, domainId, aiVoiceName, isElevenApi, token, '', '')
      // console.log('--before duration')
      // console.log(audioUrl)
      const duration = await getAudioDurationInSeconds(audioUrl); // Assuming `src` is the URL to your audio file
      // console.log('--after duration', duration)

      let newDuration = 3000
      if (videoStyle !== 'Burst') {
        newDuration =
          duration * 1000 > store.pages[index].duration
            ? duration * 1000 + 500
            : store.pages[index].duration + 500;

        if (index === store.pages.length - 1) {
          newDuration = newDuration + 1000;
        }

        store.activePage.set({ duration: newDuration });
      } else {
        newDuration =
          duration * 1000 > store.pages[index].duration
            ? duration * 1000 + 500
            : store.pages[index].duration + 500;
        newDuration = newDuration / store.pages.filter((page: any) => page.custom.scriptIndex == index).length;

        // store.activePage.set({ duration: newDuration });
      }

      let captionsResult: any;
      // await generateCaptions(audioUrl)
      if (text.length > 0) {
        try {
          captionsResult = await generateCaptions(
            audioUrl,
            userDetails?.purpose?.language || ''
          );
        } catch (e) {
          message.info('Could not generate captions for the audio');
        }
      } else {
        console.error('no caption');
      }

      await setScriptDetails((prevScript: { data: any }) => {
        const updatedScript = { ...prevScript };

        const updatedData = [...prevScript.data];

        updatedData[index] = {
          ...updatedData[index],
          name: aiVoiceName,
          elevenLabsAiVoiceId: elevenlabsVoiceId,
          url: audioUrl,
          isElevenApi: isElevenApi,
          // aiVoiceVolume: voiceOverVolume / 100,
          sounds: [{ url: audioUrl, audioDuration: duration }],
          captions: [{ text: text, words: captionsResult?.data?.words }],
        };
        if (enhancedText) {
          updatedData[index].enhancedVoiceOver = enhancedText;
        }
        return { ...updatedScript, data: updatedData };
      });

      if (videoStyle !== 'Burst') {
        store.pages[index].set({
          duration: newDuration,
          custom: {
            ...store.pages[index].custom,
            // aiVoiceVolume: voiceOverVolume / 100,
            sounds: [{ url: audioUrl, audioDuration: duration }],
            captions: [{ text: text, words: captionsResult?.data?.words }],
          },
        });
      } else {
        store.pages.map((page: any) => {
          if (page.custom.scriptIndex == index) {

            page.set({
              duration: newDuration,
              custom: {
                ...page.custom,
                sounds: [{ url: audioUrl, audioDuration: duration }],
                captions: [{ text: text, words: captionsResult.data.words }],
              },
            });
          }
        });
      }

      await prefetchAsset(audioUrl);
      setSelectedVoiceName(aiVoiceName);
      return { audioUrl, captionsResult, duration };
    } catch (error) {
      console.error('Error making text-to-speech request:', error);
    }
  };

  const handleChangeVoice = async (
    value: string,
    similarity: number,
    stability: number
  ) => {
    setIsPreviewLoading(true);
    const getCredits = await getUserDetails();
    setVoiceChanging(true);

    if (getCredits == -1) {
      message.warning('Something went wrong!');
      setVoiceChanging(false);
      setIsPreviewLoading(false);
      return;
    }
    if (getCredits?.voice_limit < 1) {
      message.warning(
        'Voice credits have been exhausted. Please upgrade the plan to use the voice.'
      );
      setVoiceChanging(false);
      setIsPreviewLoading(false);

      return;
    }
    setIsPreviewLoading(true);
    setVoiceChanging(true);
    // console.log(scriptDetails)

    await onVoiceSpeedChange(scriptDetails.aiVoiceSpeed, value);
    setVoiceChanging(false);
    setIsPreviewLoading(false);
    try {
      await creditsDeduct('voice_credits', 1)
    } catch {
      console.error('Failed to deduct credit')
    }

  };

  const handleCloneVoiceChange = async (value: string) => {
    const getCredits = await getUserDetails();
    setCustomVoiceCloning(true);
    setIsPreviewLoading(true);
    if (getCredits == -1) {
      message.warning('Something went wrong!');
      setCustomVoiceCloning(false);
      setIsPreviewLoading(false);

      return;
    }
    if (getCredits?.voice_limit < 1) {
      message.warning(
        'Voice credits have been exhausted. Please upgrade the plan to use the voice.'
      );
      setCustomVoiceCloning(false);
      setIsPreviewLoading(false);

      return;
    }

    let totalDurationInSeconds = 0;
    setCustomVoiceCloning(true);
    setIsPreviewLoading(true);

    const voiceData = ClonedVoiceData?.find((voice) => voice.id === value);
    for (let index = 0; index < scriptDetails.data.length; index++) {
      const script = scriptDetails.data[index];
      const result = await playVoiceSample(
        script.voiceOver,
        voiceData?.voice_name || '',
        true,
        voiceData?.voice_id || '',
        index,
        50,
        75
      );
      totalDurationInSeconds = totalDurationInSeconds + result.duration;
    }
    setCustomVoiceCloning(false);
    setIsPreviewLoading(false);
    const audioDurationInMins = Math.ceil(totalDurationInSeconds / 60);
    creditsDeduct('voice_credits', audioDurationInMins);
  };
  // api calls

  const handleShowVoiceOver = () => {
    setShowVoiceOver(!showVoiceOver);
  };

  const handleShowAdvancedVoiceSetting = () => {
    setshowAdvanedVoiceSetting(!showAdvanedVoiceSetting);
  };
  const handleShowAdvancedBackgroundSetting = () => {
    setShowAdvanedBackgroundSetting(!showAdvanedBackgroundSetting);
  };
  setShowAdvanedBackgroundSetting
  // const { uniqueURLs, repeatedURLs } = segregatePASURLs(categorisedMusicList)

  const categories = Object.keys(categorisedMusicList);
  const options: any = {};

  const myMusicOptions = generateMusicOptions(myMusics, audioState, togglePlayPause);

  generateCategoryMusicOptions(categories, categorisedMusicList, audioState, togglePlayPause, options);

  // ClonedVoiceData.map((voice)=>{

  // })
  const optionValues = Object.keys(options).map((option: any) => {
    return { label: option, options: options[option] };
  });

  const handleFilesAudioChange = ({ fileList }: any) => {
    if (!isSizeExceeded) setFileList(fileList);
  };
  const handleBackgroundAudioFiles = ({ fileList }: any) => {
    setBackgroundFileList(fileList);
  };
  const handleUpload = async () => {
    setIsPreviewLoading(true);
    const getCredits = await getUserDetails();
    if (getCredits == -1) {
      message.warning('Something went wrong!');

      setIsPreviewLoading(false);

      return;
    }
    if (getCredits?.voice_clones_limit < 1) {
      message.warning(
        'Please upgrade your plan to clone the voice.'
      );
      setIsPreviewLoading(false);
      return;
    }
    if (getCredits?.voice_limit < 1) {
      message.warning(
        'Please upgrade your plan to use the voice.'
      );

      setVoiceChanging(false);
      setIsPreviewLoading(false);

      return;
    }
    if (voiceName.length < 1) {
      message.warning('Pleae enter voice name.');
      setIsPreviewLoading(false);

      return;
    }
    setIsPreviewLoading(true);
    setIsCloning(true);
    try {
      const fileData: any = [];
      fileList.forEach((file: any) => {
        fileData.push(file.originFileObj);
        // Ensure filename is included
      });
      message.info('Cloning will take a few moments. Please wait.');
      const cloneVoiceId = await voiceCloneAPI(voiceName, '', fileData);
      let totalDurationInSeconds = 0;
      for (let index = 0; index < scriptDetails.data.length; index++) {
        const script = scriptDetails.data[index];
        const result = await playVoiceSample(
          script.voiceOver,
          voiceName,
          true,
          cloneVoiceId,
          index,
          50,
          75
        );
        totalDurationInSeconds = totalDurationInSeconds + result.duration;
      }
      setSelectedVoiceName(voiceName);
      message.success('Voice cloned successfully.');
      setIsPreviewLoading(false);

      try {
        const audioDurationInMins = Math.ceil(totalDurationInSeconds / 60);
        await saveClonedVoices(voiceName, cloneVoiceId);
        await creditsDeduct('voice_clones_credits', 1);
        await creditsDeduct('voice_credits', audioDurationInMins);
      } catch (error) {
        message.error('Something went wrong!');
      }
    } catch (error) {
      message.error('Upload failed.');
      console.error(error);
    } finally {
      setIsCloning(false);
      setIsPreviewLoading(false);
    }
  };

  const handleBackgroundUpload = async () => {
    setIsBackgroundUploading(true);
    try {
      if (backgroundFileList.length === 0) {
        message.warning('Please select a music file to upload');
        return;
      }

      for (const file of backgroundFileList as any) {
        // Extract the file name without extension
        const fileName = file.name || file.originFileObj.name;
        const musicName = fileName.split('.').slice(0, -1).join('.') || fileName;

        // Use the file name as the music name
        await uploadFile(file.originFileObj, musicName, 'bg');
      }

      refetchaudio();
      message.success(
        'Music uploaded successfully and available for use in the video.'
      );
      setIsBackgroundUploading(false);
      setBackgroundMusicName('');
    } catch (error) {
      console.error('Error uploading background music:', error);
      message.error('Failed to upload music file');
      setIsBackgroundUploading(false);
    }
  };

  const audioFilebeforeUpload = (file: any) => {
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('File must be smaller than 2MB!');
      setIsSizeExceeded(true);
      return false;
    }
    // console.log(isLt2M)
    // return isLt2M;
    setIsSizeExceeded(false);
    return false;
  };
  const backgroundAudioFilebeforeUpload = (file: any) => {
    const isLt2M = file.size / 1024 / 1024 < 200;

    if (!isLt2M) {
      message.error('File must be smaller than 200mb!');
      setIsSizeExceeded(true);
      return false;
    }
    // console.log(isLt2M)
    // return isLt2M;
    setIsSizeExceeded(false);
    return false;
  };
  const handleCloneDelete = async (id: string) => {
    // e.stopPropagation();
    try {
      await deleteClonedVoice(id);
      setClonedVoiceData((prevData) =>
        prevData.filter((voice) => voice.id !== id)
      );
      message.success('Voice deleted.');
    } catch (error) {
      message.warning('There was a problem deleting the cloned voice.');
    }
  };

  const handleBackgroundSound = (e: any) => {
    setScriptDetails((prevScript: { data: any }) => {
      const updatedScript = { ...prevScript };
      return { ...updatedScript, backgroundSound: e };
    });
  };
  useEffect(() => {
    async function clonedVoices() {
      try {
        const clonedVoices = await getClonedVoices();

        setClonedVoiceData(clonedVoices);
      } catch {
        console.error('Failed to get clones voices.');
      }
    }
    clonedVoices();
  }, []);
  const baseStyle: React.CSSProperties = {
    height: '100%',
    overflow: 'auto',
    backgroundColor: 'white',
    padding: '8px 0'
  };
  return (
    <div className="audio-panel">
      <Tabs defaultActiveKey="1" size="small">
        <Tabs.TabPane
          tab={
            <span style={{ fontSize: '12px' }}>
              <AudioOutlined style={{ fontSize: '14px' }} />
              Voice
            </span>
          }
          key="1"
        >
          <div className="section-container">
            <div className="tooltip-label">
              <Tooltip title={'Change the AI voice.'}>
                <h3>Change Voice</h3>
              </Tooltip>
              {subscriptionPlan === 'free' || subscriptionPlan === 'quickads_tier2' || subscriptionPlan === 'quickads_tier1' ? '' : (
                <VoiceFilterModal
                  aiVoice={aiVoice?.voices || []}
                  handleChangeVoice={handleChangeVoice}
                  selectedVoiceName={selectedVoiceName}
                />
              )}
              {voiceChanging && (
                <LoadingOutlined className="loading-indicator" />
              )}
            </div>

            <Select
              className="voice-select"
              style={{ width: '100%' }}
              placeholder='Select Voice'
              optionFilterProp='children'
              onChange={(value) => handleChangeVoice(value, 50, 75)}
              value={selectedVoiceName}
              defaultValue={selectedVoiceName}
              options={aiVoiceDropDown}
            />
            <audio ref={audioRef} src={playingUrl} style={{ display: 'none' }} />

            <div className="tooltip-label">
              <Tooltip title={'Can increase or decrease the speed of the AI voice.'}>
                <h3>AI Voice Speed</h3>
              </Tooltip>
              {isVoiceSpeedChanging && (
                <LoadingOutlined className="loading-indicator" />
              )}
            </div>
            <Slider
              style={{ width: '100%' }}
              step={0.1}
              min={0.7}
              max={1.2}
              onChange={(value) => setAiVoiceSpeed(value)}
              onChangeComplete={handleVoiceSpeedChange}
              tooltip={{ formatter: voiceSpeedformatter }}
              defaultValue={aiVoiceSpeed}
              value={typeof aiVoiceSpeed === 'number' ? aiVoiceSpeed : 1}
              disabled={isVoiceSpeedChanging}
            />

            <div className="tooltip-label">
              <Tooltip title={'Translate the audio and captions to the language you want.'}>
                <h3>Translate Audio</h3>
              </Tooltip>
              {translateloading && (
                <LoadingOutlined className="loading-indicator" />
              )}
            </div>
            <TranslateAudio
              store={store}
              translateloading={translateloading}
              setTranslateloading={setTranslateloading}
              aiVoicesResponse={aiVoicesResponse}
            />

            {/* <div className="voice-overs-section">
              <div className="tooltip-label">
                <h3>Voice Overs</h3>
                {!showVoiceOver ? (
                  <DownCircleOutlined onClick={handleShowVoiceOver} />
                ) : (
                  <UpCircleOutlined onClick={handleShowVoiceOver} />
                )}
              </div>
              <div className={`voice-overs ${showVoiceOver ? 'visible' : ''}`}>
                <h3>Voice Over Volume</h3>
                <Slider
                  style={{ width: '100%' }}
                  min={0}
                  max={100}
                  onChange={onVoiceOverVolumeChange}
                  tooltip={{ formatter }}
                  defaultValue={aiVoiceVolume}
                  value={typeof aiVoiceVolume === 'number' ? aiVoiceVolume : 0}
                />
                {scriptDetails.data.map((page: any, index: any) => (
                  <div key={index}>
                    {isSuccess && aiVoice?.voices?.length > 0 ? (
                      <AiVoiceRow
                        index={index}
                        aiVoice={aiVoice}
                        store={store}
                        voiceOverVolume={aiVoiceVolume}
                        globalVoice={selectedVoiceName}
                        showPanel={true}
                      />
                    ) : (
                      <AiVoiceRow
                        index={index}
                        aiVoice={aiVoicesResponse}
                        store={store}
                        voiceOverVolume={aiVoiceVolume}
                        globalVoice={selectedVoiceName}
                        showPanel={true}
                      />
                    )}
              </div>
                ))}
              </div>
            </div> */}
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane
          tab={
            <span style={{ fontSize: '12px' }}>
              <CustomerServiceOutlined style={{ fontSize: '14px' }} />
              Music
            </span>
          }
          key="2"
        >
          <div className="section-container">
            <h3>Background Music</h3>
            <Select
              style={{ width: '100%' }}
              placeholder='Select Background Music'
              optionFilterProp='children'
              onChange={handleBackgroundMusicChange}
              value={selectedMusicName}
              options={optionValues}
            />

            <h3>My Music</h3>
            <Select
              style={{ width: '100%' }}
              placeholder='Select Background Music'
              optionFilterProp='children'
              onChange={handleBackgroundMusicChange}
              value={selectedMusicName}
            >
              {myMusicOptions.map((option: any, index: number) => (
                <Option key={index} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>

            <div className="switch-container">
              <h3>Background Music</h3>
              <Switch
                defaultChecked={scriptDetails?.backgroundSound ?? true}
                value={scriptDetails?.backgroundSound}
                onChange={(e) => handleBackgroundSound(e)}
              />
            </div>

            <div className="upload-section">
              <Tooltip title={'Choose your desired music by entering the name and uploading the music file.'}>
                <h3>Upload Music</h3>
              </Tooltip>
              {/* <Input
            placeholder='Enter Music Name'
            defaultValue={backgroundMusicName}
            onChange={(e) => setBackgroundMusicName(e.target.value)}
                className='hoverable-text-box'
          /> */}
              <Upload
                fileList={backgroundFileList}
                onChange={handleBackgroundAudioFiles}
                beforeUpload={backgroundAudioFilebeforeUpload}
                accept='audio/*'
              >
                <Button icon={<UploadOutlined />}>Upload File</Button>
              </Upload>
              <Button
                className="action-button"
                style={{ background: 'var(--gradient-primary)', color: 'white' }}
                onClick={handleBackgroundUpload}
                disabled={backgroundFileList.length === 0}
                loading={IsBackgroundUploading}
              >
                Upload
              </Button>
            </div>

            <div>
              <h3>Background Music Volume</h3>
              <Slider
                style={{ width: '100%' }}
                min={1}
                max={100}
                onChange={onBackgroundVolumeChange}
                tooltip={{ formatter }}
                defaultValue={backgroundVolume}
                value={typeof backgroundVolume === 'number' ? backgroundVolume : 0}
              />
            </div>

            <div className="switch-container">
              <Tooltip title={'Audio fade-in and fade-out are used to lower the background sound when the AI voice is playing.'}>
                <h3>Fade Audio In/Out</h3>
              </Tooltip>
              <Switch
                size='small'
                onChange={handleFadeInOut}
                defaultChecked={scriptDetails?.audioFade || false}
                value={scriptDetails?.audioFade}
              />
            </div>
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane
          tab={
            <span style={{ fontSize: '12px' }}>
              <UserOutlined style={{ fontSize: '14px' }} />
              Clone
            </span>
          }
          key="3"
        >
          <div className="section-container">
            <div className="tooltip-label">
              <Tooltip title={'List of all cloned voices, with the option to choose any available cloned voice.'}>
                <h3>Cloned Voices</h3>
              </Tooltip>
              {customVoiceCloning && (
                <LoadingOutlined className="loading-indicator" />
              )}
            </div>

            <Select
              style={{ width: '100%' }}
              placeholder='Select voice'
              optionFilterProp='children'
              onChange={handleCloneVoiceChange}
              value={selectedVoiceName}
              defaultValue={selectedVoiceName}
              disabled={customVoiceCloning}
            >
              {ClonedVoiceData.map((voice) => (
                <Option key={voice.id} value={voice.id}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>{voice.voice_name || voice.id || ''}</span>
                    <Button
                      type='link'
                      icon={<DeleteOutlined />}
                      style={{ padding: 0 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCloneDelete(voice.id);
                      }}
                    />
                  </div>
                </Option>
              ))}
            </Select>

            <div className="clone-section">
              <Tooltip title={'Clone your desired voice by entering the name and uploading the voice sample.'}>
                <h3>Clone Voice</h3>
              </Tooltip>
              <Input
                placeholder='Enter Voice Name'
                defaultValue={voiceName}
                onChange={(e) => setVoiceName(e.target.value)}
                className='hoverable-text-box'
              />
              <Upload
                multiple
                fileList={fileList}
                onChange={handleFilesAudioChange}
                beforeUpload={audioFilebeforeUpload}
                accept='audio/*'
                maxCount={3}
              >
                <Button icon={<UploadOutlined />}>Upload Files</Button>
              </Upload>
              <Popconfirm
                title='Confirm'
                description='Confirm that you have the rights to use this voice sample before uploading.'
                placement='top'
                okText='confirm'
                onConfirm={handleUpload}
              >
                <Button
                  className="action-button"
                  style={{ background: 'var(--gradient-primary)', color: 'white' }}
                  disabled={fileList.length === 0}
                  loading={IsCloning}
                >
                  Clone
                </Button>
              </Popconfirm>
            </div>
          </div>
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export const CustomAudioPolotno = {
  name: 'audio-panel',
  Tab: (props: any) => (
    <SectionTab name='Audio' {...props}>
      <VolumeHighIcon className='sidebar-panel-tab-icon' />
    </SectionTab>
  ),
  Panel: AudioSidebar,
};
